import { UseTooltipContext } from '@ark-ui/react';
import { ButtonProps } from '@ui/lib/park/ui/button';
import { Tooltip } from '@ui/lib/park/ui/tooltip';
import { useRef } from 'react';
import { useClickAway } from 'react-use';
import { BoxProps } from 'styled-system/jsx';
/**
 * wrapper to support touch device
 */
const Root = (p: Tooltip.RootProps) => {
  return (
    <Tooltip.Root
      openDelay={0}
      interactive
      immediate
      closeDelay={0}
      closeOnPointerDown={false} // true = cancel out touch device
      closeOnClick={false} // true = cancel out touch device
      lazyMount // default
      {...p}
    />
  );
};

const Trigger = (p: ButtonProps) => {
  return (
    <>
      <Tooltip.Context>
        {(api) => {
          return (
            <Tooltip.Trigger
              {...p}
              asChild // required for useClickAway logic to work
              onClick={() => api.setOpen(!api.open)} // support touch device
            />
          );
        }}
      </Tooltip.Context>
    </>
  );
};

const ClickAwayWrappedContent = ({
  api,
  ...p
}: BoxProps & {
  api: UseTooltipContext;
}) => {
  const ref = useRef(null);
  useClickAway(ref, (e) => {
    const target = e.target as HTMLElement;
    const thisTriggerId = api.getTriggerProps().id;
    if (target.id !== thisTriggerId) {
      // requires TooltipWithTouch.Trigger to have asChild flag, else target.id wont be passed to child
      api.setOpen(false);
    }
  });

  return (
    <Tooltip.Content
      ref={ref}
      {...p}
      onClick={() => api.setOpen(false)} // click tooltip content and close
    />
  );
};

const Content = (p: BoxProps) => {
  return (
    <>
      <Tooltip.Context>
        {(api) => <ClickAwayWrappedContent {...p} api={api} />}
      </Tooltip.Context>
    </>
  );
};

export const TooltipWithTouch = {
  Root,
  Trigger,
  Positioner: Tooltip.Positioner,
  Content,
  Arrow: Tooltip.Arrow,
  ArrowTip: Tooltip.ArrowTip,
};
